var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonster2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "167px",
    viewBox: "0 0 160 167",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Monster2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "storyBackground",
    transform: "translate(-631.000000, -619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Monster2",
    transform: "translate(633.000000, 621.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHADOW",
    transform: "translate(0.000000, 4.075552)",
    fill: "#000000",
    opacity: 0.3,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2,1.42444847 C76.5369608,8.13974265 80.4389759,15.3334772 83.5409466,22.6405534 C84.4547486,22.7230533 85.3614271,22.8289336 86.2603195,22.9575611 C90.3875898,15.2845384 95.9466602,8.03851272 101.1,1.12444847 C101.723436,9.27364661 100.958756,18.8902812 100.360151,27.0779077 C109.302953,31.1527294 116.786558,37.6787455 121.85876,45.7459457 C128.760618,45.5865178 135.908264,44.9182321 142.7,45.4244485 C138.016913,50.4250324 132.924308,55.3941149 127.847253,60.1566676 C128.094572,61.2387818 128.303247,62.3346118 128.472289,63.4427216 L128.55,60.9244485 C133.05,62.4744485 137.45,63.2244485 141.15,65.1244485 C138.033101,67.3109296 132.578876,69.8436814 128.975615,71.796447 C128.926539,73.6119905 128.767607,75.4027427 128.50874,77.1628616 C133.545833,81.7664692 139.49312,87.2380412 144,92.1244485 C141.615877,92.7542167 138.846972,93.6755759 136.130769,94.0725771 C140.111804,100.555931 143.321944,107.575909 146.05,114.074448 C146.4,113.824448 147.55,113.924448 147.55,113.924448 C153.9355,114.072948 160.90906,130.393098 151.538962,130.331367 L151.25,130.324448 L151.1,130.924448 C150.05,133.724448 146.25,135.074448 145.2,132.174448 C143.75,133.624448 138.05,134.324448 141.4,129.274448 C142.1,128.174448 141.8,124.274448 141.55,125.474448 C141.15,127.374448 139.05,128.924448 136.85,127.474448 C132.6,123.924448 136.6,116.074448 141.05,114.474448 C137.814582,107.745925 134.054497,100.295984 128.971687,94.3310227 L122.237359,94.4905198 C120.225923,97.799828 117.812369,100.858466 115.060589,103.605403 L115.05,103.574448 C116.75,109.324448 118.8,117.174448 121.25,122.674448 C121.95,124.524448 118.7,122.424448 118,121.974448 C113.795,119.751115 107.534222,115.285115 103.779313,112.099304 L103.747881,112.072908 C103.20364,112.371613 102.65299,112.660864 102.096176,112.940426 C102.234172,117.60451 102.202032,122.252545 101.9,127.224448 C100.083671,125.497031 98.3189682,123.605056 96.6083501,121.605081 C98.131514,129.067563 98.7919838,133.251193 98.45,142.924448 C104.966456,141.295335 116.162162,135.035713 120.198318,140.026899 L120.35,140.224448 C120.3,140.174448 120.3,140.124448 120.3,140.074448 C120.8,140.074448 122.05,140.074448 123.4,140.824448 C124.9,141.724448 125.55,143.024448 125.75,143.474448 C125.35,144.074448 124.3,144.374448 123.7,144.224448 C124.75,145.174448 125.5,146.624448 125.65,148.674448 C126.75,149.724448 127.6,151.524448 127.25,153.624448 C126.45,152.974448 125.75,152.174448 124.9,151.524448 C124.75,151.774448 124.6,151.974448 124.45,152.174448 C124.1,152.624448 123.45,152.924448 122.7,153.124448 C121.7025,153.361948 120.389125,152.696948 119.360038,151.515267 L119.2,151.324448 L119.1,152.374448 C119.15,152.724448 119.1,153.574448 118.8,154.374448 C119.3,155.274448 119.45,156.374448 118.75,157.324448 C118.4,156.874448 117.95,156.424448 117.5,156.024448 C116.85,156.424448 115.4,156.824448 115.4,156.824448 C115.4,156.824448 111.85,157.724448 111.65,153.624448 C110.25,153.524448 109.4,153.624448 106.15,153.674448 C100.8,153.774448 97.8,153.424448 94.4,153.924448 C90.4,154.474448 87.5,154.624448 86.55,153.674448 C83,150.174448 85.1,145.524448 87.75,144.124448 C89.65,143.124448 90.8,143.924448 92.1,142.724448 C94.3,140.774448 92.95,135.674448 91.35,129.774448 C89.6813953,123.624448 89.1492158,120.974638 88.7565787,118.530969 L88.7,118.174448 L91.1479298,116.952414 C87.1823061,117.913651 83.0286007,118.424448 78.75,118.424448 C76.2650957,118.424448 73.8223185,118.252157 71.4340463,117.919397 L72.1,118.524448 C70.45,126.174448 70.45,133.074448 70.65,141.824448 C75.65,143.774448 76.75,147.224448 76.35,150.374448 C75.9,154.974448 70.25,153.274448 67.35,153.274448 C62.2708333,153.082782 56.5487847,154.130959 51.5920718,155.582851 L50.95,155.774448 L51.15,155.024448 C50.2,157.574448 47.7,158.874448 45.75,158.274448 C45.2,158.124448 44.75,157.824448 44.4,157.524448 C43.5,158.024448 42.75,158.524448 42.35,158.874448 C42.4,157.924448 42.75,156.874448 43.25,155.974448 C43.1,155.624448 43,155.374448 43,155.324448 C42.8714286,154.681591 42.8163265,154.112204 42.8346939,153.584798 L42.85,153.324448 L42.65,153.324448 C42.2,154.174448 40.05,154.374448 38.6,153.624448 C38.1,153.374448 37.7,153.074448 37.4,152.724448 C36.6,153.174448 35.85,153.624448 35.2,154.224448 C35.35,153.174448 35.8,151.774448 36.55,150.574448 C36.5,148.274448 37.45,146.574448 39,145.324448 C38.75,145.474448 38.55,145.624448 38.5,145.724448 C37.2,145.124448 36.95,145.024448 36.15,144.774448 C36.2,144.474448 36.35,143.874448 36.8,143.324448 C37.75,142.174448 39.2,142.174448 39.65,142.174448 C41.6295918,135.344857 60.9498022,140.222632 65.4166221,142.698652 L65.55,142.774448 L65.65,142.774448 C64.9625,137.824448 64.1069444,132.328268 63.5839988,127.133187 L63.45,125.724448 L65.2438878,123.495707 C63.3430303,125.744744 61.4888706,127.991444 59.9,130.124448 C58.9819731,125.610816 57.9468944,119.399932 57.399208,113.887186 C54.1744826,112.440881 51.1366319,110.674868 48.330451,108.633211 C42.5813381,111.528634 36.8070929,114.619422 31.2,116.874448 C33.1214508,111.553508 37.2974082,107.019023 41.3823824,102.516718 C39.6101512,100.635565 37.9917311,98.6197464 36.5456033,96.4873982 L39.45,101.824448 C34.2,103.224448 30.25,104.074448 25.3,104.874448 C27.0215147,100.152579 30.7268358,95.7694091 34.0360664,92.3437105 C33.7580604,91.8322092 33.4914826,91.3142372 33.2344979,90.7911109 C23.9221386,94.9534594 16.5560952,102.971153 13.5,112.874448 C13.1,114.524448 12.75,116.024448 13.55,117.124448 C21.2,114.224448 24.55,130.024448 19,127.374448 C18.2,126.024448 18.35,124.024448 16.8,123.174448 C14.05,121.574448 12.1,125.674448 13.5,127.474448 C16.55,128.824448 15.1,131.474448 12.5,132.174448 L12.6,132.174448 C11.65,132.374448 10.5,132.424448 9.55,131.324448 C9.55,131.324448 6.1,131.974448 4.8,129.824448 C-3.1,130.574448 0.1,115.574448 6.15,115.824448 C9.79578863,102.656718 17.9304257,89.7833378 30.2382818,82.9803295 C30.0603208,82.3572812 29.8967197,81.7287876 29.7462258,81.0955376 L29.9307977,81.1679934 L29.54587,81.0163718 C8.05544,72.5957635 -3.8305,73.6169485 27.8,67.9244485 L28.525289,71.9619233 C28.5084717,71.451402 28.5,70.9388703 28.5,70.4244485 C28.5,67.8468911 28.7126895,65.3167858 29.1222186,62.8492726 C26.1327351,61.3638451 23.1478905,59.8789171 20.15,58.5244485 C23.375,57.6414128 26.9021724,57.2300607 30.505151,56.959332 C33.4059783,47.4555272 39.3025549,39.1705156 47.1525493,33.0993629 C42.8871941,25.2325948 39.6974501,16.080941 36.95,7.92444847 C45.1221515,12.4836488 54.4412867,19.1888188 62.5203111,24.9844773 C64.2501253,24.4195407 66.0234797,23.94329 67.8335393,23.5602817 C68.148155,19.4008435 68.1930154,-6.2515823 72.2,1.42444847 Z M85.7,119.224448 C85.05,122.524448 84.9,125.024448 84.3,127.974448 C81.516,125.766448 77.62608,121.945648 75.5498688,119.520151 L75.3,119.224448 L85.7,119.224448 Z M34.45,45.2244485 L30.75,55.5244485 L29.5492873,54.7520265 C25.7468254,52.2997319 21.9619048,49.7577818 18.75,46.2744485 C21.3,45.9244485 30.5,44.7244485 34.45,45.2244485 Z M25.6,27.7244485 C32.15,28.6744485 38.85,32.3244485 45.2,34.3744485 L45.45,34.3244485 L35.25,43.4744485 C32.1,38.4744485 27.7,33.3244485 25.6,27.7244485 Z M118.693078,39.433 L119,39.6744485 C118.875,39.7577818 118.680556,39.8758374 118.561343,39.9128744 L118.5,39.9244485 L118.693078,39.433 Z M118.725903,39.3534428 L118.693078,39.433 L108.8,31.6244485 C126.5705,18.3089485 126.11114,20.6750485 118.725903,39.3534428 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#BB3584",
    cx: 78.75,
    cy: 70.5,
    rx: 50.25,
    ry: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(28.500000, 22.500000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "oval-shadow",
    fill: "#000000",
    opacity: 0.2,
    cx: 50.25,
    cy: 48,
    rx: 50.25,
    ry: 48
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#BB3584",
    cx: 48,
    cy: 46.75,
    rx: 48,
    ry: 45.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "background-spikes",
    transform: "translate(8.433078, 0.075552)",
    fill: "#BB3584",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.9669221,111.774448 C98.6669221,114.974448 105.216922,119.674448 109.566922,121.974448 C110.266922,122.424448 113.516922,124.524448 112.816922,122.674448 C110.366922,117.174448 108.316922,109.324448 106.616922,103.574448",
    id: "STROKE_f5c3b38d-c832-4d08-9695-dd48f2c102cd",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8169221,43.4744485 C23.6669221,38.4744485 19.2669221,33.3244485 17.1669221,27.7244485 C23.7169221,28.6744485 30.4169221,32.3244485 36.7669221,34.3744485 L37.0169221,34.3244485",
    id: "STROKE_401f0712-0ecc-4c78-910b-960ef468b9a3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7669221,81.2744485 C-0.133077912,72.5744485 -12.5830779,73.6744485 19.3669221,67.9244485",
    id: "STROKE_5556b1a6-03b2-4a80-a684-75621e316176",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3669221,23.9244485 C59.7169221,21.2744485 59.6169221,-6.52555153 63.7669221,1.42444847 C68.4169221,8.62444847 72.5669221,16.3744485 75.7669221,24.2244485 C75.8169221,24.1744485 75.8669221,24.1244485 75.9169221,24.0744485",
    id: "STROKE_d4285c1d-4741-4fcd-ac90-86f339355a45",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.366922,31.6244485 C118.316922,18.1744485 117.666922,20.7244485 110.066922,39.9244485 C110.166922,39.9244485 110.416922,39.7744485 110.566922,39.6744485",
    id: "STROKE_14537928-0d0f-434b-90db-40249dd40634",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8669221,119.224448 C68.8669221,121.624448 72.9669221,125.674448 75.8669221,127.974448 C76.4669221,125.024448 76.6169221,122.524448 77.2669221,119.224448",
    id: "STROKE_d78ac0eb-7c60-4632-a9d1-7b114231e733_1_",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7669221,92.1744485 C22.4169221,95.6244485 18.6169221,100.074448 16.8669221,104.874448 C21.8169221,104.074448 25.7669221,103.224448 31.0169221,101.824448",
    id: "STROKE_33c2a9ea-545f-4972-be24-55949317c1cc",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.116922,60.9244485 C124.616922,62.4744485 129.016922,63.2244485 132.716922,65.1244485 C129.366922,67.4744485 123.316922,70.2244485 119.766922,72.2244485",
    id: "STROKE_29f89da6-0f26-457e-9cbb-9a871b2367cd_1_",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3169221,55.5244485 C18.1169221,52.8244485 13.8669221,50.1244485 10.3169221,46.2744485 C12.8669221,45.9244485 22.0669221,44.7244485 26.0169221,45.2244485",
    id: "STROKE_e2c320d8-4f60-40d7-a13b-852d0ee2707f_2_",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.966922,94.510386 L126.791531,94.1847024 C129.791531,93.8847024 132.916922,92.8244485 135.566922,92.1244485 C130.816922,86.9744485 124.466922,81.1744485 119.266922,76.4244485",
    id: "STROKE_ab7c5d5b-df24-44c1-80f8-74d2fc4a0cf8",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "arms_bkg",
    transform: "translate(0.000000, 74.000000)",
    fill: "#BB3584"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.05,10.45 C128.15,14.85 135.4,28.8 141.05,40.55 C136.6,42.15 132.6,50 136.85,53.55 C139.05,55 141.15,53.45 141.55,51.55 C141.8,50.35 142.1,54.25 141.4,55.35 C138.05,60.4 143.75,59.7 145.2,58.25 C146.25,61.15 150.05,59.8 151.1,57 L151.25,56.4 C161.05,56.8 154,40.15 147.55,40 C147.55,40 146.4,39.9 146.05,40.15 C139.9,25.5 131.3,8.2 116.95,0.35",
    id: "STROKE_066835d0-cc6e-4db7-a092-b2543308290c_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.85,14.25 C28.6,16.5 17.45,26.15 13.5,38.95 C13.1,40.6 12.75,42.1 13.55,43.2 C21.2,40.3 24.55,56.1 19,53.45 C18.2,52.1 18.35,50.1 16.8,49.25 C14.05,47.65 12.1,51.75 13.5,53.55 C16.55,54.9 15.1,57.55 12.5,58.25 L12.6,58.25 C11.65,58.45 10.5,58.5 9.55,57.4 C9.55,57.4 6.1,58.05 4.8,55.9 C-3.1,56.65 0.1,41.65 6.15,41.9 C10.4,26.55 20.75,11.6 36.7,6.2",
    id: "STROKE_9312e184-2d21-4e07-9744-cf7adb22d3da_1_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "feet_bkg",
    transform: "translate(35.000000, 116.000000)",
    fill: "#BB3584",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.65,25.9 C35.45,17.15 35.45,10.25 37.1,2.6 L35.45,1.1 L28.45,9.8 C28.95,15.4 29.9,21.45 30.65,26.85 C30.6,26.85 30.6,26.85 30.55,26.85 C26.35,24.4 6.65,19.35 4.65,26.25 C4.2,26.25 2.75,26.25 1.8,27.4 C1.35,27.95 1.2,28.55 1.15,28.85 C1.95,29.1 2.2,29.2 3.5,29.8 C3.55,29.7 3.75,29.55 4,29.4 C2.45,30.65 1.5,32.35 1.55,34.65 C0.8,35.85 0.35,37.25 0.2,38.3 C0.85,37.7 1.6,37.25 2.4,36.8 C2.7,37.15 3.1,37.45 3.6,37.7 C5.05,38.45 7.2,38.25 7.65,37.4 L7.85,37.4 C7.8,38 7.85,38.65 8,39.4 C8,39.45 8.1,39.7 8.25,40.05 C7.75,40.95 7.4,42 7.35,42.95 C7.75,42.6 8.5,42.1 9.4,41.6 C9.75,41.9 10.2,42.2 10.75,42.35 C12.7,42.95 15.2,41.65 16.15,39.1 L15.95,39.85 C21.05,38.3 27.05,37.15 32.35,37.35 C35.25,37.35 40.9,39.05 41.35,34.45 C41.75,31.3 40.65,27.85 35.65,25.9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.65,32.75 C90.5,30.7 89.75,29.25 88.7,28.3 C89.3,28.45 90.35,28.15 90.75,27.55 C90.55,27.1 89.9,25.8 88.4,24.9 C87.05,24.15 85.8,24.15 85.3,24.15 C85.3,24.2 85.3,24.25 85.35,24.3 C81.45,18.95 70.05,25.35 63.45,27 C63.8,17.1 63.1,12.95 61.5,5.15 L57.4,0.4 L53.7,2.25 C54.1,4.8 54.6,7.4 56.35,13.85 C57.95,19.75 59.3,24.85 57.1,26.8 C55.8,28 54.65,27.2 52.75,28.2 C50.1,29.6 48,34.25 51.55,37.75 C52.5,38.7 55.4,38.55 59.4,38 C62.8,37.5 65.8,37.85 71.15,37.75 C74.4,37.7 75.25,37.6 76.65,37.7 C76.85,41.8 80.4,40.9 80.4,40.9 C80.4,40.9 81.85,40.5 82.5,40.1 C82.95,40.5 83.4,40.95 83.75,41.4 C84.45,40.45 84.3,39.35 83.8,38.45 C84.1,37.65 84.15,36.8 84.1,36.45 L84.2,35.4 C85.25,36.7 86.65,37.45 87.7,37.2 C88.45,37 89.1,36.7 89.45,36.25 C89.6,36.05 89.75,35.85 89.9,35.6 C90.75,36.25 91.45,37.05 92.25,37.7 C92.6,35.6 91.75,33.8 90.65,32.75 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left_foot",
    transform: "translate(35.000000, 118.500000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4,6.75 C28.9,12.35 29.9,18.95 30.65,24.35 C23.35,23.6 1.15,21.2 1.55,32.25 C1.45,33.1 2.1,34.4 3.6,35.15 C5.05,35.9 7.2,35.7 7.65,34.85 C7.9,34.35 7.45,33.5 7.9,32.55 C8.05,32.3 9.25,32.1 9.3,32",
    id: "STROKE_8ee5507e-155c-4871-88ef-65d7c23ecb6e",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9,28.7 C24.1,29.05 5.85,27.6 8,36.85 C8.05,37.05 8.75,39.25 10.75,39.8 C12.7,40.4 15.2,39.1 16.15,36.55",
    id: "STROKE_209c0a37-aaf2-4be3-b03b-9a1fa2d61755",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1,0.1 C35.45,7.75 35.45,14.65 35.65,23.4 C40.65,25.35 41.75,28.8 41.35,31.9 C40.9,36.5 35.25,34.8 32.35,34.8 C27.05,34.6 21.05,35.75 15.95,37.3",
    id: "STROKE_f0c4bcf4-d496-49c8-b50a-90c833d586ce",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.65,24.4 C26.3,21.75 2.55,15.7 4.6,26.2",
    id: "STROKE_7f25a34f-4d07-41a3-a506-4c26fadf7ad8",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "toenails",
    transform: "translate(0.200000, 23.744727)",
    fill: "#38DEED",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75,8.35527344 C5.8,7.70527344 4.95,5.75527344 3.75,6.25527344 C1.7,6.80527344 0.25,10.1052734 4.4408921e-16,12.0052734 C1.5,10.6052734 3.35,10.1552734 5.75,8.35527344 Z",
    id: "STROKE_5ccde9e9-02f7-4a60-ab60-e7e02690fc67",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55,0.0052734375 C4.35,0.0052734375 2.65,-0.144726563 1.6,1.15527344 C1.15,1.70527344 1,2.30527344 0.95,2.60527344 C1.75,2.85527344 2,2.95527344 3.3,3.55527344 C3.5,3.15527344 6.65,1.50527344 6.65,1.50527344 C6.85,1.55527344 5.55,0.255273437 4.55,0.0052734375 Z",
    id: "STROKE_a9357748-8a09-43cf-8f3f-05c100f61071",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.85,11.0552734 C8.85,11.8552734 7.3,14.4052734 7.15,16.6552734 C8.25,15.6552734 12.75,13.4052734 12.75,13.4052734 C12.75,13.4052734 12.75,10.6052734 10.85,11.0552734 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "right_foot",
    transform: "translate(84.500000, 118.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3.2 C13.6,11 14.3,15.15 13.95,25.05 C21.35,23.25 34.75,15.4 36.9,24.8",
    id: "STROKE_401b1c12-62ff-4ad9-9667-c23924f04734",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25,26.85 C25.2,26.45 40.75,19.95 41.2,31.25 C41.25,31.85 40.9,33.15 39.95,34.3 C39.6,34.75 38.95,35.05 38.2,35.25 C36.95,35.55 35.2,34.4 34.15,32.65",
    id: "STROKE_cbfa5a8e-aabe-4097-889e-450b03e3b929",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,30.5 C18.9,30.4 34,26.45 34.6,34.5 C34.65,35.1 34.5,37.1 33.15,38.05 C32.6,38.45 30.9,38.95 30.9,38.95 C30.9,38.95 27.35,39.85 27.15,35.75 C25.75,35.65 24.9,35.75 21.65,35.8 C16.3,35.9 13.3,35.55 9.9,36.05 C5.9,36.6 3,36.75 2.05,35.8 C-1.5,32.3 0.6,27.65 3.25,26.25 C5.15,25.25 6.3,26.05 7.6,24.85 C9.8,22.9 8.45,17.8 6.85,11.9 C5.1,5.45 4.6,2.85 4.2,0.3",
    id: "STROKE_172f7b34-a5f5-412c-afbd-768b2180db6e_1_",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "toenails",
    transform: "translate(30.190049, 22.200000)",
    fill: "#38DEED",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00995075866,14.35 C1.35995076,14.8 3.05995076,15.9 4.05995076,17.25 C6.30995076,14.15 -0.290049241,9.55 0.00995075866,14.35 Z",
    id: "STROKE_b966ca4c-7207-46a4-b02e-5e2f34ac2c8d",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75995076,10.5 C7.80995076,10.55 8.30995076,10.6 8.35995076,10.6 C10.1099508,10.9 11.2599508,12.55 12.5599508,13.55 C13.4599508,8.2 6.70995076,4.85 7.75995076,10.5 Z",
    id: "STROKE_f59bca6c-dd84-4df7-8795-ea5f21b75c72",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60995076,1.42108547e-14 C6.10995076,1.42108547e-14 7.35995076,1.42108547e-14 8.70995076,0.75 C10.2099508,1.65 10.8599508,2.95 11.0599508,3.4 C10.6599508,4 9.45995076,4.35 8.90995076,4.1 C8.50995076,3.95 7.80995076,2.85 6.70995076,2.6 C6.45995076,1.5 5.65995076,0.4 5.60995076,1.42108547e-14 Z",
    id: "STROKE_ccdfa33d-3e96-4fb1-831f-213988bc35a0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Virus_3",
    transform: "translate(20.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-spikes",
    transform: "translate(0.150000, 0.200000)",
    fill: "#BB3584",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2,25.65 C68.4,16.55 74.95,8.05 80.95,0 C81.65,9.15 80.6,20.15 80,28.9",
    id: "STROKE_5969157d-2596-489a-9398-5e5b4a289d83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9,44.65 C105.95,44.75 114.5,43.7 122.55,44.3 C116.65,50.6 110.1,56.85 103.75,62.7",
    id: "STROKE_0ef5c349-5236-42a3-bd6b-52d8b5eaa834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.85,101.5 C68.25,109.95 74.6,119.3 81.75,126.1 C82.4,115.4 81.8,106.2 80.95,95.1",
    id: "STROKE_d34d2c42-df21-4d47-96fa-554869012bef_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8,91.85 C24,100 14.3,106.75 11.05,115.75 C20.25,112.05 29.9,106.1 39.15,102.45",
    id: "STROKE_9ddcf768-e0a9-4939-bc81-0ce3aea8336e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,68.9 C16.5,65.9 8.3,61.15 -1.77635684e-15,57.4 C8.4,55.1 18.85,56 27.35,54.25",
    id: "STROKE_53937af1-30c9-418c-a42d-0dada1da31dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2,35.75 C23.8,27.15 20,16.3 16.8,6.8 C26.3,12.1 37.35,20.3 46.2,26.6",
    id: "STROKE_5c21b3de-1f8c-4fc7-8472-5464ddcff548_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,109.55 C36.8,109.55 37,108 36.9,107.95 C37.15,114.3 38.55,123.1 39.75,129 C43.4,124.1 48.45,118.6 52.25,113.85",
    id: "STROKE_eea87a39-3d21-4b81-a4aa-4f20769beb56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.15,33 C18.05,37.65 13.2,46.45 10.05,54.95",
    id: "STROKE_81e861f1-c5a8-43d8-8573-70ab905b88f1_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25,62.3 C7.07910156,67.4967448 9.3,79.3 11.2,81",
    id: "STROKE_ab1e76cd-3190-4013-981a-f11172ef39b8",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.95,90.7 C16.05,95 17.35,98.8 21.6,101.35",
    id: "STROKE_8e46aa5f-f173-4a9d-8b01-70b38a79e911",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.95,24.95 C50.2,22.95 57.95,22.75 64.4,23.5",
    id: "STROKE_fe9ecc84-6253-4fd3-8bc6-cff0fb5b4770",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.95,27.35 C90.05,30.3 97.5,35.9 102.55,44.3",
    id: "STROKE_76a658b9-4bab-401a-8949-b93143f10450",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55,60 C109.3,65.6 108,73.9 106.6,80.4",
    id: "STROKE_cc6a0db9-a6d0-4663-8fc3-a2b5a0f3018d",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,88.7 C100.25,98.35 92.55,107.15 82.75,110.85",
    id: "STROKE_f2fec57a-23cf-4780-911b-dd6ede963077",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6,117.45 L51.6,117.5 C58.15,118.75 65.9,118.95 72.05,116.1",
    id: "STROKE_bae361d9-0fb9-4e38-a5de-8383ede42619",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,107.4 C32.2,109.45 33.85,110.2 37,110.75",
    id: "STROKE_2e7318f3-0b2a-422b-807f-637a92fb0034",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8,46.9 C72,44.8 78.05,42.3 82.85,42.1",
    id: "STROKE_04746673-b224-4a39-a896-7272213663c6",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3,42.65 C47.55,42.15 53.05,45.5 58.6,47.75",
    id: "STROKE_9080ef33-28e4-4f0b-af3a-4c2c4952fe17",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left-eye",
    transform: "translate(37.518173, 48.858235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3818268,12.7417653 C25.1318268,-5.70823471 -3.36817322,-3.15823471 0.331826781,14.1917653 C2.38182678,23.9417653 22.0318268,22.3917653 23.3818268,12.7417653 Z",
    id: "STROKE_e3037c9f-e4b1-4e83-a6ba-f3b8bed8a3a5",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38182678,10.6917653 C8.28182678,10.7417653 8.08182678,10.8417653 7.93182678,10.9917653 C7.48182678,11.4417653 7.58182678,12.1417653 7.58182678,12.2417653 C7.63182678,12.9917653 7.93182678,13.3917653 8.28182678,13.5417653 C8.98182678,13.8417653 10.1818268,12.8917653 10.1818268,11.8417653 C10.1818268,11.2917653 9.83182678,10.8917653 9.68182678,10.7417653 C9.23182678,10.4917653 8.98182678,10.3917653 8.38182678,10.6917653 Z",
    id: "STROKE_100e0c68-45c6-47b1-91ea-08498de673f2",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2818268,8.79176529 C12.2318268,8.74176529 12.2318268,11.8417653 10.2818268,11.7917653 C8.33182678,11.8417653 8.33182678,8.79176529 10.2818268,8.79176529 Z",
    id: "STROKE_8e5e0530-8c72-4963-9486-ca1ed27e0171",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right-eye",
    transform: "translate(67.487280, 48.951192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8127198,7.49880772 C18.2127198,-1.25119228 8.51271977,-1.65119228 3.36271977,2.74880772 C-0.487280234,6.04880772 -1.13728023,12.8488077 1.96271977,16.9488077 C6.06271977,22.3988077 18.0127198,21.6988077 20.5627198,14.8488077 C21.3627198,12.5488077 21.4127198,9.54880772 20.8127198,7.49880772",
    id: "STROKE_c1de529b-9b80-4009-8620-7952ccb96b87",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41271977,11.7488077 C6.96271977,10.7988077 5.66271977,12.7488077 7.21271977,13.5988077 C7.86271977,13.8988077 8.91271977,13.7488077 9.06271977,12.6988077 C9.11271977,12.1988077 8.81271977,11.9988077 8.41271977,11.7488077",
    id: "STROKE_dcda3163-2e51-4df1-ae65-a2c54a81e7b4",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36271977,9.59880772 C11.3127198,9.54880772 11.3127198,12.6488077 9.36271977,12.5988077 C7.41271977,12.6488077 7.41271977,9.59880772 9.36271977,9.59880772 Z",
    id: "STROKE_627d2b4c-6c09-4e2e-bc08-98ea755b4937",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mouth",
    transform: "translate(37.500000, 74.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1,1.8 C33.9,-0.8 18.7,8.32667268e-17 4.35,2.1 C-1.75,3.55 0.2,10 2.2,14 C16.65,14.25 31.75,14.65 46.05,12.55 C50,11.3 49.35,4.95 48.1,1.8",
    id: "STROKE_f156c8ef-04f0-4760-9bd0-8254e2299538_1_",
    fill: "#2D4060",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8,14.4 C30.9,14.55 19.85,14.7 19.85,14.7 C19.85,14.7 23.95,6.7 24.5,6.35 C25.05,6 30.7,14.3 30.8,14.4 Z M18.9,1 C19,1.6 14.9,8.35 13.4,8.95 C11.7790698,7.71046512 9.38537047,2.5161709 9.16620738,2.03566227 L9.15,2 C9.15,2 17.3,1.2 18.9,1 Z M42.9,1.65 C42.9,1.65 37.45,8.65 36.95,8.45 C36.45,8.25 32.75,0.8 32.75,0.8 C34.2,0.7 42.9,1.65 42.9,1.65 Z",
    id: "Combined-Shape-Copy",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "teeth",
    transform: "translate(9.000000, 0.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8,13.9 C21.9,14.05 10.85,14.2 10.85,14.2 C10.85,14.2 14.95,6.2 15.5,5.85 C16.05,5.5 21.7,13.8 21.8,13.9 Z M9.9,0.5 C10,1.1 5.9,7.85 4.4,8.45 C2.77906977,7.21046512 0.385370471,2.0161709 0.166207378,1.53566227 L0.15,1.5 C0.15,1.5 8.3,0.7 9.9,0.5 Z M33.9,1.15 C33.9,1.15 28.45,8.15 27.95,7.95 C27.45,7.75 23.75,0.3 23.75,0.3 C25.2,0.2 33.9,1.15 33.9,1.15 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,1.8 C33.9,-0.8 18.7,8.32667268e-17 4.35,2.1 C-1.75,3.55 0.2,10 2.2,14 C16.65,14.25 31.75,14.65 46.05,12.55 C50,11.3 49.35,4.95 48.1,1.8",
    id: "STROKE_f156c8ef-04f0-4760-9bd0-8254e2299538_2_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "left_arm",
    transform: "translate(0.000000, 80.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7,0.2 C20.75,5.6 10.4,20.55 6.15,35.9 C0.1,35.65 -3.1,50.6 4.8,49.9",
    id: "STROKE_87300f2b-1484-4e10-ab31-7fd0b875fd9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,44.1 C3.35,46.8 3.45,52.3 9.55,51.4",
    id: "STROKE_c14a0d61-bb3a-431b-bcba-e960cd28b71d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.85,8.25 C28.6,10.5 17.45,20.15 13.5,32.95 C13.1,34.6 12.75,36.1 13.55,37.2 C21.2,34.3 24.55,50.1 19,47.45 C18.2,46.1 18.35,44.1 16.8,43.25 C14.05,41.65 12.1,45.75 13.5,47.55 C16.55,48.9 15.1,51.55 12.5,52.25 L12.6,52.25 C8.55,53.3 7.75,47.5 9.6,44.95",
    id: "STROKE_9312e184-2d21-4e07-9744-cf7adb22d3da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right_arm",
    transform: "translate(115.000000, 74.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.05,10.45 C13.15,14.85 20.4,28.8 26.05,40.55 C21.6,42.15 17.6,50 21.85,53.55 C25.4,55.95 28.85,50.25 24.85,48.35 C25,47.4 25.85,46.95 26.7,46.7",
    id: "STROKE_30c9c603-00ab-4f41-ae15-38aff211551f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95,0.35 C16.3,8.2 24.9,25.5 31.05,40.15 C31.4,39.9 32.55,40 32.55,40 C39,40.15 46.05,56.8 36.25,56.4",
    id: "STROKE_b82c3e23-3e2d-4716-81a4-c27bbe596023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9,48.6 C36.8,51 37.15,54.9 35.8,57.65 C34.65,60 31.35,60.9 30.2,58.25",
    id: "STROKE_2c7f6fb9-0987-4ea4-86dd-b21954440e37_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,51.7 C27.95,52.95 27.1,54.25 26.4,55.35 C21.6,61.6 34.35,61.05 31.5,50.6",
    id: "STROKE_066835d0-cc6e-4db7-a092-b2543308290c"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonster2);
export default __webpack_public_path__ + "static/media/Monster2.853238574feb91345c084c833241f640.svg";
export { ForwardRef as ReactComponent };